export default __webpack_public_path__ + "static/media/Asset_race.b9a69cea.png";